import config from './config';

export default config;

export function isProduction() {
    return config.app.env === 'prod';
}

export function isLocal() {
    return config.app.env === 'local';
}

export function getEnvDisplayName() {
    return config.app.env[0]?.toUpperCase() + config.app.env.substring(1);
}
